import CloseIcon from "@mui/icons-material/Close";
import Logger from "../../services/Logger";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { BootstrapDialog } from "../components/BootstrapDialogTitle";
import CustomButton from "../components/CustomButton";

export default function MailingCardDialog({ open, setOpen, selectionId }) {
    useEffect(() => {
        // Logger.log("selectionId==" + selectionId);
    }, [selectionId]);

    const [company, setCompany] = useState("");
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [created, setCreated] = useState("");
    const [subject, setSubject] = useState("");
    const [comment, setComment] = useState("");

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveComment = () => {};

    return (
        <div>
            <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Contact details
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <TextField
                        label="Company"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Full Name"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Email"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Created"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={created}
                        onChange={(e) => setCreated(e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Subject"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        margin="normal"
                    />
                    <TextField
                        label="Comment"
                        variant="standard" // Change variant to standard
                        fullWidth
                        multiline
                        rows={4}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <CustomButton variant={"contained"} onClick={handleSaveComment}>
                        Save
                    </CustomButton>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
